//chapter1
export default {
    id : 19,//chapter number
    title : '19. PFMEA 작성방법 (6) - PFMEA 위험분석',//chapter name
    slides : [
        {
            title : 'Intro',
            type : 'intro',
            source : 'c19.mp4',
        },
        {
            title : 'Today’s Goal',
            type : 'plan',
            body1 : [
                'PFMEA 위험분석',
            ],
            body2 : [
                'PFMEA 위험분석에 대해 설명할 수 있다.'
            ],
            bgm : "plan.mp3"
        },
        {
            title : 'Lesson',
            type : 'lesson',
            source : '19.mp4',
        },
        {
            title : 'Quiz',
            type : 'quiz',
            quiz : [
                {
                    type : 'ox',
                    question : '공정 FMEA 발생도는 실제 발생률로써 판단한다.',//html available
                    answer : "2",
                    explain : '발생의 가능성으로 평가된다.'
                },
                {
                    type : 'ox',
                    question : '공정 FMEA 검출도는 고장원인과 고장형태를 검출할 확률로 평가한다.',//html available
                    answer : "1",
                    explain : '검츨의 가능성으로 평가된다.'
                },
            ],
            quizMask : "../assets/images/quiz_intro.jpg",//quiz mask
            bgm : "quiz.mp3"
        },
        {
            title : 'Summary',
            type : 'summary',
            /*download : 'sample.pptx',//data folder*/
            print : false,// true : show, false: hide
            slides : [
                {
                    body : `<ul>
                        <h3>1. 위험분석 개요</h3>
                        <li>현 예방관리와 검출관리의 Risk 평가<br>
                        1) 예방관리의 과제(existing or planned)<br>
                        2) 검출관리의 과제(existing or planned)<br>
                        3) Rating of S, O, D for each failure chain<br>
                        4) Collaboration between Customer and supplier(Severity)<br>
                        5) action priority(AP)의 평가</li>
                    </ul>`
                },
                {
                    body : `<ul>
                        <h3>2. 현설계 관리의 이해</h3>
                        <li>예방방법과 검출방법 이해 : 현재 사용 중 혹은 계획된 방법으로부터 평가</li>
                        <p class="mg10"></p>
                        <h3>3. 심각도, 발생도, 검출도와 평가방법</h3>
                        <li>발생도 : 현재 예방관리 상태에서 고장의 특정한 원인이 발생할 수 있는 가능성</li>
                        <li>검출도 : 현 공정관리의 검출형태의 목록으로부터 가장 효과적인 고장원인 또는 고장형태를 검출할 확률의 평가</li>
                        <p class="mg10"></p>
                        <h3>4. AP 평가 방법</h3>
                        <p class="mg10"></p>
                        <h3>5. 양식 사용방법</h3>
                    </ul>`
                },
            ],
            bgm : "summary.mp3"
        },
        {
            title : 'Outro',
            type : 'outro',
            source : 'c19.mp4',
        },
    ]
}